import React, { useEffect } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import GradeTabs from 'containers/Student/Marks/Read/Tabs/Grades';
// import ViewTabs from 'containers/Student/Marks/Read/Tabs/Views';

import Summary from 'containers/Student/Marks/Summary';
import Report from 'containers/Student/Marks/Report';
import Certificate from 'containers/Student/Marks/Certificate';

import { useAppStore } from 'store/useAppStore';
import { useStudentMarkStore } from 'store/student/useStudentMarkStore';

// Store request parameters
const parameters = {
	eager: '[grades.program, courses.subject, takes.exam, marks.subject]'
};

const Read = () => {
	// Use app's store
	const id = useAppStore(state => state.user.id);

	// Use student's mark store
	const [view, onInit, onReset] = useStudentMarkStore(state => [
		state.view,
		state.onInit,
		state.onReset
	]);

	// Store requested user
	const [[, progress], collect] = useCollect(`users/${id}`, parameters, onInit);

	// Collect marks on mount and on parameter change
	useSingleEffect(() => {
		(async () => await collect())();
	});

	// Reset state on unmount
	useEffect(() => {
		return () => onReset();
	}, []);

	return (
		<div className="space-y-4">
			<Title
				title="Sekmes"
				className="text-2xl"
			/>

			<Progress progress={progress} />

			<Show if={!progress}>
				<div className="p-4 bg-white dark:bg-neutral-800 rounded-lg">
					{/* Grade tabs */}
					<GradeTabs />

					{/* View tabs */}
					{/* <ViewTabs /> */}

					{/* Mark summary */}
					<Show if={view === 'summary'}>
						<Summary />
					</Show>

					{/* Mark report */}
					<Show if={view === 'report'}>
						<Report />
					</Show>

					{/* Mark certificate */}
					<Show if={view === 'certificate'}>
						<Certificate />
					</Show>
				</div>
			</Show>
		</div>
	);
};

export default Read;